import { useCallback, useEffect, useState } from 'react';
import { css } from '@emotion/react';
import * as Sentry from '@sentry/react';
import { Input } from '~/components/atomic';
import { fetchCheckUserName } from '~/api';
import { useDebounce } from '~/hooks';
import { useSignUpStepStore } from '~/store';
import ErrorText from '../Error/ErrorText';
import * as S from './Profile.styled';

const CHECK_EMAIL_TIME = 500;
const USER_VALIDATE_MSG = 'This account name already exists.';

interface UsernameProps {
  setUsernameValid: (isValid: boolean) => void;
}

export default function UserName({ setUsernameValid }: UsernameProps) {
  const { name, setName } = useSignUpStepStore((state) => ({
    name: state.profile.name,
    setName: state.setName,
  }));

  const [error, setError] = useState('');

  const debouncedUserName = useDebounce(name, CHECK_EMAIL_TIME);

  const checkUserName = useCallback(async () => {
    try {
      const { data } = await fetchCheckUserName({
        username: debouncedUserName,
      });
      //이미 있는 이름이라면 0 아니라면 1
      if (!data.used) {
        setError('');
        setUsernameValid(true);
      } else {
        setError(USER_VALIDATE_MSG);
        setUsernameValid(false);
      }
    } catch (error) {
      console.error(error);
    }
  }, [debouncedUserName]);

  useEffect(() => {
    if (debouncedUserName === '') {
      setError('');
      setUsernameValid(false);
      return;
    }

    checkUserName();
  }, [debouncedUserName, checkUserName]);

  return (
    <>
      <S.Container>
        <Input
          id='SignUpProfileName'
          label='Username'
          placeholder='Mark'
          text={name}
          setText={setName}
          textLengthOpt
          maxText={20}
        />
        {error && (
          <div
            css={css`
              position: absolute;
              bottom: -3px;
            `}
          >
            <ErrorText error={error} />
          </div>
        )}
      </S.Container>
    </>
  );
}
